<script>
import bem from '@/utils/bem';
import { mapActions, mapGetters } from 'vuex';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';
import { ColorPicker } from 'vue3-colorpicker';
import columns from '@/pages/settings/statusesTab/columns';

const b = bem('statuses-tab');
export default {
  components: {
    ModalWrapper,
    ColorPicker,
  },
  data() {
    return {
      selectedStatus: null,
      isShowPopup: false,
      columns: columns(),
      newName: '',
      newColor: '',
    };
  },
  methods: {
    ...mapActions({
      getStatusesAction: 'admin/getStatuses',
      saveStatusAction: 'admin/saveStatus',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    save() {
      this.saveStatusAction({
        id: this.selectedStatus.id,
        displayName: this.newName,
        color: this.newColor,
      });
      this.isShowPopup = false;
      this.selectedStatus = null;
      this.newName = '';
      this.newColor = '';
    },
    cancel() {
      this.isShowPopup = false;
      this.selectedStatus = null;
      this.newName = '';
      this.newColor = '';
    },
    clickEdit(status) {
      this.isShowPopup = true;
      this.selectedStatus = status;
      this.newName = status.displayName;
      this.newColor = status.color || '';
    },
  },
  mounted() {
    this.getStatusesAction();
  },
  computed: {
    ...mapGetters({
      statusList: 'admin/getStatusList',
    }),
  },
};
</script>

<template>
  <div :class="b()">
    <a-table
      :columns="columns"
      :dataSource="statusList"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'actions'">
          <div class="action-buttons">
            <a-button
              type="primary"
              html-type="button"
              @click="clickEdit(record)"
            >
              Edit
            </a-button>
          </div>
        </template>
      </template>
    </a-table>
    <modal-wrapper v-model:show="isShowPopup" width="600px" >
      <div :class="b('modal-content')">
        <a-input
          placeholder="Search by name..."
          style="max-width: 350px"
          v-model:value="newName"
        />
        <ColorPicker
          v-model:pureColor="newColor"
          :format="'hex6'"
          :isWidget="true"
          :disableAlpha="true"
        />
        <div :class="b('modal-buttons-wrap')" >
          <a-button
            type="primary"
            html-type="button"
            @click="save()"
          >
            Save
          </a-button>
          <a-button
            html-type="button"
            @click="cancel()"
          >
            Cancel
          </a-button>
        </div>
      </div>
    </modal-wrapper>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
